export default [
  {
    path: '/Account/Login',
    component: () => import('@/views/Account/Login'),
    name: 'Login',
    meta: {
      title: '登录',
      noCache: false,
      affix: true
    }
  },
  {
    path: '/Account/Reg',
    component: () => import('@/views/Account/Reg'),
    name: 'Reg',
    meta: {
      title: '注册',
      noCache: false,
      affix: true,
      keepAlive: true
    }
  },
  {
    path: '/Account/Service',
    component: () => import('@/views/Account/Service'),
    name: 'Service',
    meta: {
      title: '注册协议',
      noCache: false,
      affix: true
    }
  },
  {
    path: '/Account/FindPwd',
    component: () => import('@/views/Account/FindPwd'),
    name: 'FindPwd',
    meta: {
      title: '找回密码',
      noCache: false,
      affix: true
    }
  },
  {
    path: '/Account/BindWeChat',
    component: () => import('@/views/Account/BindWeChat'),
    name: 'BindWeChat',
    meta: {
      title: '绑定微信回调处理',
      noCache: false,
      affix: true
    }
  },
  {
    path: '/Account/GetCode',
    component: () => import('@/views/Account/GetCode'),
    name: 'GetCode',
    meta: {
      title: '获取code',
      noCache: false,
      affix: true
    }
  }
]
